module.exports = __webpack_public_path__ + "img/otf4.b8c51831.png";